// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { InterfaceMsg_abstract } from './../abstract/SagaBase/InterfaceMsg_abstract';
export class InterfaceMsg extends InterfaceMsg_abstract {}
